import { renderToStaticMarkup } from 'react-dom/server';
import sanitizeHtml from 'sanitize-html';

var getTextFromElement = function getTextFromElement(element) {
  return sanitizeHtml(renderToStaticMarkup(element), {
    allowedTags: [],
    allowedAttributes: []
  });
};

export default getTextFromElement;
//# sourceMappingURL=getTextFromElement.js.map